
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function PageFooter() {
  const [email, setEmail] = useState('');
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !email.includes('@')) {
      setFormStatus('error');
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }

    setFormStatus('submitting');

    try {
      const response = await fetch('https://readdy.ai/api/form/d6ave85bd17lru29m400', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });

      if (response.ok) {
        setFormStatus('success');
        setEmail('');
        setTimeout(() => setFormStatus('idle'), 3000);
      } else {
        setFormStatus('error');
        setTimeout(() => setFormStatus('idle'), 3000);
      }
    } catch (err) {
      console.error('Newsletter subscription failed:', err);
      setFormStatus('error');
      setTimeout(() => setFormStatus('idle'), 3000);
    }
  };

  return (
    <footer className="bg-stone-100 px-5 md:px-8 py-12 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-10 md:mb-16">
          <div>
            <div className="flex items-center gap-2 mb-3 md:mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-leaf-fill text-emerald-600 text-lg"></i>
              </div>
              <span
                className="text-lg md:text-xl font-bold text-gray-900"
                style={{ fontFamily: 'Noto Serif KR, serif' }}
              >
                자연담은
              </span>
            </div>
            <p className="text-gray-500 text-xs md:text-sm leading-relaxed mb-5 md:mb-6">
              자연이 주는 건강한 에너지,
              <br />
              스피루리나와 약손콩으로
              <br />
              건강한 내일을 시작하세요.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                rel="nofollow"
                className="w-9 h-9 md:w-10 md:h-10 bg-emerald-600 rounded-full flex items-center justify-center hover:bg-emerald-700 transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-white text-sm md:text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="#"
                rel="nofollow"
                className="w-9 h-9 md:w-10 md:h-10 bg-emerald-600 rounded-full flex items-center justify-center hover:bg-emerald-700 transition-all cursor-pointer"
              >
                <i className="ri-kakao-talk-fill text-white text-sm md:text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="#"
                rel="nofollow"
                className="w-9 h-9 md:w-10 md:h-10 bg-emerald-600 rounded-full flex items-center justify-center hover:bg-emerald-700 transition-all cursor-pointer"
              >
                <i className="ri-youtube-line text-white text-sm md:text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4 md:mb-6">
              <a href="#quick-links">바로가기</a>
            </h4>
            <ul className="space-y-2.5 md:space-y-3">
              <li>
                <Link
                  to="/products"
                  className="text-xs md:text-sm text-gray-500 hover:text-emerald-600 transition-colors cursor-pointer"
                >
                  제품소개
                </Link>
              </li>
              <li>
                <Link
                  to="/story"
                  className="text-xs md:text-sm text-gray-500 hover:text-emerald-600 transition-colors cursor-pointer"
                >
                  브랜드 스토리
                </Link>
              </li>
              <li>
                <Link
                  to="/reviews"
                  className="text-xs md:text-sm text-gray-500 hover:text-emerald-600 transition-colors cursor-pointer"
                >
                  고객후기
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4 md:mb-6">
              <a href="#cs-info">고객지원</a>
            </h4>
            <ul className="space-y-2.5 md:space-y-3">
              <li className="text-xs md:text-sm text-gray-500">전화: 02-3487-2025</li>
              <li className="text-xs md:text-sm text-gray-500">이메일: homedr365@gmail.com</li>
              <li className="text-xs md:text-sm text-gray-500">평일 09:00 - 18:00</li>
              <li className="text-xs md:text-sm text-gray-500">주말/공휴일 휴무</li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4 md:mb-6">
              <a href="#newsletter">건강 소식 받기</a>
            </h4>
            <p className="text-xs md:text-sm text-gray-500 mb-3 md:mb-4 leading-relaxed">
              최신 건강 정보와 할인 소식을 받아보세요
            </p>
            <form
              onSubmit={handleSubmit}
              data-readdy-form
              id="newsletter-footer"
              className="space-y-2.5 md:space-y-3"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="이메일 주소 입력"
                className="w-full px-4 py-2.5 md:py-3 rounded-lg bg-white border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 transition-all text-xs md:text-sm"
                disabled={formStatus === 'submitting'}
                required
              />
              <button
                type="submit"
                disabled={formStatus === 'submitting'}
                className="w-full px-4 py-2.5 md:py-3 bg-emerald-600 text-white rounded-lg font-semibold hover:bg-emerald-700 transition-all whitespace-nowrap cursor-pointer disabled:opacity-50 text-xs md:text-sm"
              >
                {formStatus === 'submitting'
                  ? '구독 중...'
                  : formStatus === 'success'
                  ? '구독 완료!'
                  : '구독하기'}
              </button>
            </form>
            {formStatus === 'error' && (
              <p className="text-red-500 text-[10px] md:text-xs mt-2">
                올바른 이메일 주소를 입력해주세요
              </p>
            )}
          </div>
        </div>

        <div className="pt-6 md:pt-8 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-400 text-xs md:text-sm">
            &copy; 2025 자연담은. All rights reserved.
          </p>
          <div className="flex items-center gap-4 md:gap-6 flex-wrap justify-center">
            <a
              href="#"
              className="text-xs md:text-sm text-gray-400 hover:text-emerald-600 transition-colors cursor-pointer"
            >
              개인정보처리방침
            </a>
            <a
              href="#"
              className="text-xs md:text-sm text-gray-400 hover:text-emerald-600 transition-colors cursor-pointer"
            >
              이용약관
            </a>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs md:text-sm text-gray-400 hover:text-emerald-600 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
